import actions from './webhooksActions'

export default {
  actions,
}
